// src/api/paymentsApi.js
import axios from "axios";
import { Auth_Proto, Auth_Domain, Auth_Port } from "../Component/consts";

const api = axios.create({
    baseURL: `${Auth_Proto}${Auth_Domain}${Auth_Port}/api/masters`,
});

export const paymentsApi = {
    create: (data) => api.post("/payments/create", data),
    verify: (data) => api.post("/payments/verify", data),
    capture: (data) => api.post("/payments/capture", data),
    refund: (data) => api.post("/payments/refund", data),
    cancel: (data) => api.post("/payments/cancel", data),
    getById: (id) => api.get(`/payments/${id}`),
    getByReference: (reference) => api.get(`/payments/reference/${reference}`),
    getByOrder: (orderId) => api.get(`/payments/order/${orderId}`),
    search: (params) => api.get("/payments", { params }),
    update: (id, data) => api.put(`/payments/${id}`, data),
    remove: (id) => api.delete(`/payments/${id}`),
};